
import React,{Component} from "react";
import EachOut from "./EachOut";
import Grid from '@material-ui/core/Grid';
import {Link} from "react-router-dom";
import "./card.css"; 
class Out extends Component {

render(){


return (



this.props.OUTLETS.map((e)=>{




return (

<Grid item md={4} xs={12} sm={6} key={e.outletId } id="zoom">
<Link to={{
pathname:"/food-booking/" + this.props.trainN +"/"+ this.props.trainNo + "/" + this.props.doj +"/"+this.props.sch+"/" + e.provider +"/"+e.deliveryCharge + "/"+ this.props.statC + "/" +e.minOrderAmount +"/"+this.props.statN+"/"+ e.outletName +"/"+ e.outletId 


}} style={{textDecoration:"none"}}>
<EachOut statC={this.props.statC}  statN={this.props.statN} sch={this.props.sch} day={this.props.day} 
details={e}   

/>
</Link>
</Grid>

)
}
)




)



};

};
export default Out;